/**
 * helpers.js
 */

import React from 'react';
import { Types } from 'utils/constants';
import Icon from 'components/icon';


export const shrinkOptionalWidth = 850;


export const getOdorSummary = (detectionEnvironments) => {
  let odorNames = [];
  if (detectionEnvironments) {
    detectionEnvironments.forEach(env => {
      env.odorEnvironments.forEach(odorEnv => {
        odorEnv.odors.forEach(odor => {
          const name = odor.type?.name;
          if (name.length && !odorNames.includes(name)) {
            odorNames.push(odor.type?.name);
          }
        });
      });
    });
  }

  const isProofingOnly = (odorNames.length === 1 && odorNames[0] === 'Proofing');
  const targetNames = odorNames.filter(name => name !== 'Proofing');

  return isProofingOnly
    ? 'Proofing Only'
    : targetNames.length === 0
      ? 'No Odors'
      : targetNames.length === 1
        ? targetNames[0]
        : 'Multiple Types';
}


export const getPatrolSummary = (recordType, patrolTypes, t) => {
  if (!patrolTypes) return "None";
  const patrolNames = patrolTypes.map(pt => Types.Patrol.getName(t, pt.type));

  return patrolNames.length === 0
    ? 'No Types'
    : patrolNames.length === 1
      ? patrolNames[0]
      : recordType === Types.Record.EXERCISE
        ? `Scenario`
        : `Multiple Types`;
}


export const getReviewStatusObj = (id, name, reviewObj) => {
  let icon = '';
  let status = '';
  if (reviewObj) {
    if (reviewObj.status === Types.ReviewStatus.REJECTED) {
      icon = <Icon type='rejected' className='icon-error' />;
      status = 'Rejected';
    }
    if (reviewObj.status === Types.ReviewStatus.ACCEPTED) {
      icon = <Icon type='reviewed' className='icon-complete' />;
      status = 'Reviewed';
    }
    if (reviewObj.status === Types.ReviewStatus.NOT_REVIEWED) {
      icon = <Icon type='not-reviewed' className='icon-incomplete' />;
      status = 'Not Reviewed';
    }
  }

  return {
    id,
    name,
    icon,
    status
  };
}